<form data-abide [formGroup]="editAuthPolicyForm" (ngSubmit)="onSubmit()" name="editAuthPolicyForm" novalidate>

  <div class="content-header">
    Authorizers
  </div>

  <div class="header-helper">
    This lists the authorizers for the domain and their permissions to approve change requests.
  </div>
  <common-alerts [errorsInput]="errors"></common-alerts>
  <div class="grid-x" *ngIf="modifiedAuthPolicy?.users.length>0">
    <div class="cell large-4 small-12 medium-6 content-sub-header">
      Name
    </div>
    <div class="cell large-1 medium-0 small-0"></div>

    <div class="cell large-6 small-12 medium-6 content-sub-header">
      Request Type
    </div>
  </div>
  <div formArrayName="users">
    <div *ngFor="let formUser of formUsers.controls; let i=index;">
      <div class="grid-x" [formGroupName]="i">
        <div class="cell large-4 medium-6 small-12" style="display: flex; align-items: center">
          <div style="display: flex;">
            <fa-icon (click)="removeAuthorizer(formUser.value.email)" [icon]="'trash'" class="delete-icon "></fa-icon>
            <lib-user-link [user]="formUser.value" style="margin-left: 16px"></lib-user-link>
            <span class="text-helper wrap-text">&nbsp;&nbsp;{{formUser.value.email}}</span>
          </div>
        </div>
        <div class="cell large-1 medium-0 small-0"></div>
        <div class="cell large-7 medium-6 small-12 align-center-space-between">
          <span class="request-type-checkbox">
            <input type="checkbox" formControlName="all"/>
            <label>
              All
            </label>
          </span>
          <span class="request-type-checkbox">
            <input type="checkbox" formControlName="control"/>
            <label>
              Change of Control
            </label>
          </span>
          <span class="request-type-checkbox">
            <input type="checkbox" formControlName="nonTechnical"/>
            <label>
              Non-Technical
            </label>
          </span>
          <span class="request-type-checkbox">
            <input type="checkbox" formControlName="technical"/>
            <label>
              Technical
            </label>
          </span>
          <span class="request-type-checkbox">
            <input type="checkbox" formControlName="authPolicy"/>
            <label>
              Authorization Policy
            </label>
          </span>
        </div>
      </div>
    </div>

    <a class="a-link" (click)="addAuthorizer()">Add Authorizer</a>

  </div>

  <div class="content-header" style="margin-top: 24px !important;">
    Authorizations Needed
  </div>

  <div class="header-helper">
    This lists the thresholds for each change request type. The authorization policy can be set to: All -
    all authorizers in the group must approve; Majority - a majority of authorizers in the group
    must approve (50% of authorizers + 1); or Minimum - a set number, minimum, of authorizers must approve. If you select a minimum,
    you must make sure you have at least that number of authorizers for that request type group.
  </div>
  <div class="grid-x">
    <div class="cell large-2 small-12 medium-6 content-sub-header">
      Request Type
    </div>
    <div class="cell large-6 small-12 medium-6 content-sub-header ">
      Threshold
    </div>
  </div>
  <div [formGroupName]="'policies'">
    <div class="grid-x">
      <div class="cell large-2 small-12 medium-6 ">
        <label>Change of Control</label>
      </div>
      <div class="cell large-6 small-12 medium-6 align-center-space-between">
        <label>
          <input type="radio" formControlName="control" value="All">
          All
        </label>
        <label>
          <input type="radio" formControlName="control" value="Majority">
          Majority
        </label>
        <div class="align-center">
          <label>
            <input type="radio" formControlName="control" value="Limit">
            <span style="margin-right: 3px">Minimum</span>

          </label>
          <input formControlName="controlValue" [ngClass]="editAuthPolicyForm.getRawValue() | policyCssHelper : 'control'" type="number" [max]="controlLimit" [min]="1"/>
        </div>
      </div>
    </div>
    <div class="grid-x">
      <div class="cell large-2 small-12 medium-6 ">
        <label>Non-Technical</label>
      </div>
      <div class="cell large-6 small-12 medium-6 align-center-space-between">
        <label>
          <input type="radio" formControlName="nonTechnical" value="All">
          All
        </label>
        <label>
          <input type="radio" formControlName="nonTechnical" value="Majority">
          Majority
        </label>
        <div class="align-center">

          <label>
            <input type="radio" formControlName="nonTechnical" value="Limit">
            <span style="margin-right: 3px">Minimum</span>
          </label>
          <input formControlName="nonTechnicalValue" [ngClass]="editAuthPolicyForm.getRawValue() | policyCssHelper : 'nonTechnical'" type="number" [max]="nonTechnicalLimit"
                 [min]="1"/>
        </div>
      </div>
    </div>
    <div class="grid-x">
      <div class="cell large-2 small-12 medium-6 ">
        <label>Technical</label>
      </div>
      <div class="cell large-6 small-12 medium-6 align-center-space-between">
        <label>
          <input type="radio" formControlName="technical" value="All">
          All
        </label>
        <label>
          <input type="radio" formControlName="technical" value="Majority">
          Majority
        </label>
        <div class="align-center">
          <label>
            <input type="radio" formControlName="technical" value="Limit">
            <span style="margin-right: 3px">Minimum</span>
          </label>
          <input formControlName="technicalValue" [ngClass]="editAuthPolicyForm.getRawValue() | policyCssHelper : 'technical'" type="number" [max]="technicalLimit" [min]="1"/>
        </div>
      </div>
    </div>
    <div class="grid-x">
      <div class="cell large-2 small-12 medium-6 ">
        <label>Authorization Policy</label>
      </div>
      <div class="cell large-6 small-12 medium-6 align-center-space-between">
        <label>
          <input type="radio" formControlName="authPolicy" value="All">
          All
        </label>
        <label>
          <input type="radio" formControlName="authPolicy" value="Majority">
          Majority
        </label>
        <div class="align-center">
          <label>
            <input type="radio" formControlName="authPolicy" value="Limit">
            <span style="margin-right: 3px">Minimum</span>
          </label>
          <input formControlName="authPolicyValue" [ngClass]="editAuthPolicyForm.getRawValue() | policyCssHelper : 'authPolicy'" type="number" [max]="authPolicyLimit" [min]="1"/>
        </div>
      </div>
    </div>

  </div>
  <div class="grid-x save-cancel-button-group">
    <button class="iana-button-cancel" (click)="cancel()">{{newDelegation ? "Previous" : "Cancel"}}</button>
    <button class="iana-button" [disabled]="!editAuthPolicyForm.valid" type="submit">{{newDelegation ? "Next" : "Save"}}</button>
  </div>
</form>
<add-user-modal [users]="modifiedAuthPolicy.users" (userVOOutput)="addUserSubmit($event)"></add-user-modal>
